module.exports = __webpack_public_path__ + "img/portrait-010.d31c00e4.jpg";